<table>
  <thead>
    <tr>
      <th>Révision</th>
      <th style="width: 250px">Dernière modification</th>
      <th style="width: 50px;"></th>
    </tr>
  </thead>
  <tbody *ngIf="revisions && revisions.length > 0">
    <tr *ngFor="let revision of revisions" (click)="onSelect(revision)">
      <td name="Révision">
        {{ revision.number }}
      </td>
      <td name="Dernière modification" style="width: 250px">
        {{ revision.updated_at | tzdate }}
      </td>
      <td style="width: 50px;" class="actions">
        <a class="action-btn">
          <t-icon name="arrow_forward"></t-icon>
        </a>
      </td>
    </tr>
  </tbody>

  <tbody *ngIf="!revisions || revisions.length == 0">
    <tr>
      <td class="text-center" colspan="3">
        <ng-container *ngIf="revisions && revisions.length == 0">
          Aucune révision avec l'état production n'a été trouvée
        </ng-container>
        <ng-container *ngIf="!revisions">
          Chargement...
        </ng-container>
      </td>
    </tr>
  </tbody>
  
</table>